/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable one-var */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable dot-notation */
import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Moment from 'moment';
import { Controlled as CodeMirror } from 'react-codemirror2';
import {
    sortBy as _sortBy,
    isEqual as _isEqual,
    cloneDeep as _cloneDeep,
} from 'lodash';
import clsx from 'clsx';

import { makeStyles, useTheme } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Tooltip from '@mui/material/Tooltip';
import { DataGridPro, useGridApiRef as useApiRef } from '@mui/x-data-grid-pro';

import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';
import SelectIcon from '@mui/icons-material/LibraryAddCheck';
import DeselectIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';

import Searchbar from '../../../components/searchbar';
import Push from '../../../components/push/';

import ZeekService from '../../../data/zeek-service';
import PolicyService from '../../../data/policy-service';
import Auth, { ProfileContext } from '../../../data/auth-service';

import useWindowSize from '../../../libraries/usewindowsize';
import Helpers from '../../../libraries/helpers';
import Animations from '../../../libraries/animations';
import HighlightText from '../../../components/highlightText';
import {LoadingOverlay, NoRowsOverlay} from '../../../components/xgrid/overlays';

const useStyles = makeStyles(theme => ({
    justifySpace: {
        justifyContent: 'space-between',
    },
    formControl: {
        margin: theme.spacing(1),
        width: '100%',
    },
    ruleGroups: {
        maxHeight: '150px',
    },
    rulesCard: {
        height: '50%',
    },
    buttonRight: {
        float: 'right',
        marginLeft: theme.spacing(1),
    },
    controlBar: {
        display: 'none',
    },
    zeekLink: {
        color: theme.palette.text.primary,
    },
    codeContainer: {
        height: '114px',
        '& .react-codemirror2': {
            height: '100%',
        },
        '& .CodeMirror': {
            height: '100%',
        }
    },
    ...Animations.Push(theme),
    warningBox: {
        border: `1px solid ${theme.palette.warning.main}`,
        background: theme.styled.paper.background,
        padding: theme.spacing(2),
    },
}));

const Zeek = () => {
    const classes = useStyles();
    const theme = useTheme();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [settings, setSettings] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [policyType] = useState('bro_ti');
    const [, setFilter] = useState('');
    const [, setZeekTable] = useState(false);
    const [search, setSearch] = useState('');
    const [scripts, setScripts] = useState([]);
    const [searchScripts, setSearchScripts] = useState([]);
    const [zeekConfig, setZeekConfig] = useState({ content: '' });
    const [ogZeek, setOGZeek] = useState([]);
    const [ogZeekConfig, setOGZeekConfig] = useState({});
    const [zeekChanges, setZeekChanges] = useState(false);
    const [zeekConfigChanges, setZeekConfigChanges] = useState(false);
    const [editor, setEditor] = useState(null);
    const [mode, setMode] = useState('zeek');
    const [sort, setSort] = useState([{ field: 'name', sort: 'asc' }]);
    const [disableHistory, setDisableHistory] = useState({ undo: false, redo: false });
    const { height } = useWindowSize();
    const tableAPIRef = useApiRef();
    const { updateProfile, getProfile } = useContext(ProfileContext);
    const [columnWidth, setColumnWidth] = useState({});

    const MC2CHECK = process.env.BRICATA_APPLIANCE_TYPE === 'mc2';
    const zeekPerms = Auth.permissions.get('ZeekScriptsPolicy');
    const zeekEditorPerms = Auth.permissions.get('ZeekScripts');
    const [readonly] = useState(!zeekPerms.write || (zeekPerms.override ? false : (!MC2CHECK && location.pathname.includes('.mc2'))));
    const [pushing, setPushing] = useState(false);

    const searchRef = React.useRef(search);

    useEffect(() => {
        getZeekConfig();

        setColumnWidth(getProfile('zeek').widths || {});
    }, []);

    useEffect(() => {
        setZeekChanges(!_isEqual(scripts, ogZeek));
    }, [scripts]);

    useEffect(() => {
        setZeekConfigChanges(!_isEqual(zeekConfig, ogZeekConfig));

        if (editor) {
            setDisableHistory({
                undo: Boolean(editor.getHistory().done.length),
                redo: Boolean(editor.getHistory().undone.length),
            });
        }
    }, [zeekConfig]);

    useEffect(() => {
        getScripts(search);
    }, [search]);

    const handleColumnResize = params => {
        const widths = tableAPIRef.current.getAllColumns().reduce((a, c) => {
            a[c.headerName] = c.width;
            return a;
        }, {});
        updateProfile('zeek', {
            ...getProfile('zeek'),
            widths: widths,
        });
        setColumnWidth(widths);
    };

    const handleColumnReorder = () => {
        let order = [];
        setTimeout(() => {
            order = tableAPIRef.current.getAllColumns().reduce((a, c) => {
                a.push(c.headerName);
                return a;
            }, []);

            updateProfile('zeek', {
                ...getProfile('zeek'),
                columns: order,
            });
        });
    };

    const getScripts = (search, revert) => {
        setZeekTable(true);
        ZeekService.getScriptsList(params.policy, 'bro_ti', search).then(res => {
            res = _sortBy(res, [sort[0].field]);
            if (sort[0].sort === 'asc') {
                res.reverse();
            }

            if (location && location.state) {
                location.state.scripts.forEach((v) => {
                    const i = res.findIndex(x => x.name === v.name);
                    res[i].enabled = v.enabled;
                });
            }

            res = res.map(v => {
                v = { ...v, id: Helpers.UniqueID() };
                return v;
            });
            setOGZeek(_cloneDeep(res));

            if (!revert) {
                res = res.map(v => {
                    const match = scripts.findIndex(x => x.name === v.name);
                    if (match !== -1) v.enabled = scripts[match].enabled;
                    return v;
                });
            }

            navigate({ state: null });

            if (!search) {
                setScripts(_cloneDeep(res));
            }
            setSearchScripts(_cloneDeep(res));
        });
    };

    const getZeekConfig = () => {
        ZeekService.getPolicyConfiguration(params.policy, 'bro_ti').then(res => {
            setOGZeekConfig(_cloneDeep(res));
            setZeekConfig(res);
        });
    };

    const handleToggleSettings = () => {
        setSettings(!settings);
    };

    const handleDeployPolicy = (sensorList) => {
        setPushing(true);
        ZeekService.updateScriptsList(params.policy, 'bro_ti', scripts).then(() => {
            toast.success('Zeek policy saved successfully');
            getScripts(search);
            getZeekConfig();
            setMode('zeek');

            if (sensorList.length || Object.keys(sensorList).length) {
                PolicyService.assignPolicy('bro_ti', params.policy, sensorList).then(res => {
                    toast.success('Policy pushed to sensor(s) successfully');
                }, err => {
                    if (typeof err === 'string') {
                        toast.error('Pushing policy to new sensor(s) failed : ' + err);
                    } else {
                        toast.error(err.message + ', ' + err.error);
                    }
                });
            }
        }, err => {
            if (err) {
                toast.error(err.message + ': ' + err.error);
            }
        }).finally(() => { setPushing(false) });
    };

    const handleRevertPolicy = () => {
        setSearchScripts([]);
        setScripts([]);
        getScripts('', true);
        getZeekConfig();
    };

    const handleScriptEnable = (e, d) => {
        const s1 = [...scripts],
            s2 = [...searchScripts];
        s1[s1.findIndex(v => v.name === d.row.name && v.folder === d.row.folder)].enabled = e.target.checked;
        s2[s2.findIndex(v => v.name === d.row.name && v.folder === d.row.folder)].enabled = e.target.checked;
        setScripts(s1);
        setSearchScripts(s2);
    };

    const handleSearch = ({ search }) => {
        setSearch(search);
        searchRef.current = search;
    };

    const handleUpdateZeekConfig = (c, e, data) => {
        setZeekConfig({ ...zeekConfig, content: data });
    };

    const handleModeChange = (v) => {
        setMode(v);
        if (v === 'zeek') {
            getScripts(search);
        }
    };

    const handleDeselectAll = () => {
        let s1 = [...scripts],
            s2 = [...searchScripts];

        if (search) {
            s2 = s2.map((v) => { return { ...v, enabled: false } });
            s2.forEach(v => {
                s1[s1.findIndex(x => x.name === v.name)].enabled = false;
            });
        } else {
            s1 = s1.map((v) => { return { ...v, enabled: false } });
        }

        setScripts(s1);
        setSearchScripts(s2);
    };

    const handleSelectAll = () => {
        let s1 = [...scripts],
            s2 = [...searchScripts];

        if (search) {
            s2 = s2.map((v) => { return { ...v, enabled: true } });
            s2.forEach(v => {
                s1[s1.findIndex(x => x.name === v.name)].enabled = true;
            });
        } else {
            s1 = s1.map((v) => { return { ...v, enabled: true } });
        }

        setScripts(s1);
        setSearchScripts(s2);
    };

    const handleUndo = () => {
        editor.undo();
    };

    const handleRedo = () => {
        editor.redo();
    };

    const handleSaveZeekSettings = () => {
        ZeekService.updatePolicyConfiguration(params.policy, 'bro_ti', zeekConfig).then(() => {
            getZeekConfig();
        }, err => {
            toast.error('Failed to set Zeek settings ::: ', err);
        });
    };

    const handleRevertZeekSettings = () => {
        setZeekConfig(_cloneDeep(ogZeekConfig));
    };

    const tableRenderers = {
        name: d => {
            return (
                <Link
                    className={classes.zeekLink}
                    aria-label={d.row.name}
                    to={`/policies/zeek/scripts/editor/${d.row.name}`}
                    state={{
                        author: d.row.author,
                        policy: params.policy,
                        bt: false,
                        scripts: scripts,
                    }}
                ><HighlightText text={d.row.name} search={searchRef?.current}></HighlightText></Link>
            );
        },
        purpose: d => { return <div><HighlightText text={d.row.purpose} search={searchRef?.current}></HighlightText></div> },
        library: d => { return <div><HighlightText text={d.row.folder} search={searchRef?.current}></HighlightText></div> },
        author: d => { return <div><HighlightText text={d.row.author} search={searchRef?.current}></HighlightText></div> },
        modified: d => { return <div>{Moment(d.row.time).format(theme.date.long)}</div> },
        version: d => { return <div>{d.row.ver}</div> },
        enabled: d => {
            return (
                <FormControlLabel
                    label=""
                    control={
                        <Checkbox
                            disabled={readonly}
                            checked={d.row.enabled}
                            onClick={(e) => { handleScriptEnable(e, d) }}
                        />
                    }
                />
            );
        }
    };

    const codemirrorOptions = {
        lineNumbers: true,
        theme: theme.codeMirror.theme,
        mode: 'zeek',
    };

    const handleTableSort = (s) => {
        if (!_isEqual(s, sort)) {
            setSort(s);
        }
    };

    const handleImportScripts = (e) => {
        ZeekService.uploadBroScriptsFile(policyType, e.target.files[0]).then(res => {
            getScripts();
            toast.success('Zeek script imported successfully');
        }, err => {
            toast.error(err.error);
        });
    };

    const handleOpenExports = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleCloseExports = () => {
        setAnchorEl(null);
    };

    const handleFilportClick = (name) => {
        if (anchorEl.name === 'filter') {
            setFilter(name);
        } else {
            ZeekService.downloadBroScriptsLibrary(name, policyType).then(res => {
                const a = document.createElement('a');
                a.target = '_blank';
                a.download = `${name}.tgz`;
                a.href = URL.createObjectURL(new Blob([res], { type: 'application/octet-stream' }), `${name}.tgz`);
                a.click();
            });
        }
        setAnchorEl(null);
    };

    return (
        <main>
            <Grid container spacing={2}>
                <Grid container item xs={12} style={{ display: mode === 'push' ? 'none' : 'flex' }}>
                    <Grid item xs={6}>
                        <Searchbar immediate onSearch={handleSearch} searchservice={ZeekService} value={search} />
                    </Grid>
                    <Grid item container xs={6} justifyContent='flex-end'>
                        {zeekEditorPerms.write && <Box ml={1}>
                            <input
                                id="zeek-script-file"
                                type="file"
                                style={{ display: 'none' }}
                                onClick={e => { e.target.value = null }}
                                onChange={handleImportScripts}
                            />
                            <label htmlFor="zeek-script-file">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    aria-label="import"
                                >
                                    Import
                                </Button>
                            </label>
                        </Box>}
                        {zeekEditorPerms.admin && <Box ml={1}>
                            <Button
                                name="export"
                                variant="contained"
                                color="primary"
                                aria-label="export"
                                onClick={handleOpenExports}
                            >
                                Export
                            </Button>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleCloseExports}
                            >
                                {anchorEl && anchorEl.name === 'filter' && <MenuItem onClick={() => { handleFilportClick('') }}>All</MenuItem>}
                                <MenuItem onClick={() => { handleFilportClick('user_custom') }}>User Custom</MenuItem>
                                <MenuItem onClick={() => { handleFilportClick('bricata') }}>OpenText™ NDR</MenuItem>
                                <MenuItem onClick={() => { handleFilportClick('imported_scripts') }}>Imported Scripts</MenuItem>
                                <MenuItem onClick={() => { handleFilportClick('imported_indicators') }}>Imported Indicators</MenuItem>
                            </Menu>
                        </Box>}
                        {!readonly && <Box ml={1}><Button
                            variant="contained"
                            aria-label="settings"
                            onClick={handleToggleSettings}><SettingsIcon /> Settings</Button></Box>}
                        {!readonly && <Box ml={1}><Link to="/policies/zeek/scripts/editor" state={{
                            author: '',
                            policy: params.policy,
                            bt: false,
                            scripts: scripts,
                        }} aria-label="edit link" >
                            <Button
                                variant="contained"
                                aria-label="edit btn"
                                color="primary"
                                disabled={!MC2CHECK && location.pathname.includes('.mc2')}
                            >Editor</Button>
                        </Link></Box>}
                        {zeekPerms.admin && <Box ml={1}><Button
                            variant="contained"
                            color="primary"
                            aria-label="push"
                            onClick={() => { handleModeChange('push') }}
                            disabled={!MC2CHECK && location.pathname.includes('.mc2')}
                            className={clsx({
                                [classes.pushAnimation]: !(!MC2CHECK && location.pathname.includes('.mc2')) && zeekChanges,
                            })}
                        >Push</Button></Box>}
                        {!readonly && <Box ml={1}><Button
                            variant="contained"
                            color="secondary"
                            aria-label="revert"
                            onClick={handleRevertPolicy}
                            disabled={!MC2CHECK && location.pathname.includes('.mc2')}
                        >Revert</Button></Box>}
                    </Grid>
                    <Grid item xs={12}>
                        {!MC2CHECK && location.pathname.includes('.mc2') && <Box mt={1} mb={-2} className={classes.warningBox} display="inline-block">
                            You cannot modify or push a policy assigned by an MC2.
                        </Box>}
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Box>
                        <Accordion elevation={3} expanded={settings}>
                            <AccordionSummary className={classes.controlBar}></AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <IconButton
                                            className={classes.buttonRight}
                                            aria-label="close"
                                            onClick={handleToggleSettings}
                                            size="large"><CloseIcon /></IconButton>
                                    </Grid>
                                    <Grid item xs={12} style={{ marginTop: '-50px' }}>
                                        <Button variant="outlined" onClick={handleUndo} disabled={!disableHistory.undo}><UndoIcon /></Button>
                                        <Button variant="outlined" onClick={handleRedo} disabled={!disableHistory.redo}><RedoIcon /></Button>
                                        <Box className={classes.codeContainer}>
                                            <CodeMirror
                                                editorDidMount={e => { setEditor(e) }}
                                                value={zeekConfig.content}
                                                onBeforeChange={handleUpdateZeekConfig}
                                                options={codemirrorOptions}
                                            />
                                        </Box>
                                        <Box mt={3.5} width="100%" display="flex" justifyContent="flex-end">
                                            <Box ml={2}><Button variant="contained" color="secondary" aria-label="cancel zeek settings" onClick={handleRevertZeekSettings}>Cancel Settings</Button></Box>
                                            <Box ml={2}><Button variant="contained" color="primary" aria-label="save zeek settings" onClick={handleSaveZeekSettings} disabled={!zeekConfigChanges}>Save Settings</Button></Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                </Grid>
            </Grid>
            <Box py={2}>
                <Box display={mode === 'push' ? 'block' : 'none'}>
                    {zeekPerms.admin && <Push
                        pushClasses={classes.buttonRight}
                        policyName={params.policy}
                        policyType={'bro_ti'}
                        onDeploy={handleDeployPolicy}
                        closePush={() => { handleModeChange('zeek') }}
                        pushing={pushing}
                        permName={'ZeekScriptsPolicy'}
                    />}
                </Box>
                <Box display={mode === 'zeek' ? 'block' : 'none'} width="100%" height={height - 300}>
                    <DataGridPro
                        apiRef={tableAPIRef}
                        rows={Boolean(search) ? searchScripts : scripts}
                        components={{
                            Header: readonly ? undefined : () => {
                                return (
                                    <Box p={2}>
                                        <Tooltip title="Deselect All">
                                            <IconButton
                                                className={classes.buttonRight}
                                                aria-label="deselect all"
                                                onClick={handleDeselectAll}
                                                size="large"><DeselectIcon /></IconButton>
                                        </Tooltip>
                                        <Tooltip title="Select All">
                                            <IconButton
                                                className={classes.buttonRight}
                                                aria-label="select all"
                                                onClick={handleSelectAll}
                                                size="large"><SelectIcon /></IconButton>
                                        </Tooltip>
                                    </Box>
                                );
                            },
                            LoadingOverlay:LoadingOverlay,
                            NoRowsOverlay:NoRowsOverlay
                        }}
                        columns={(() => {
                            const p = getProfile('zeek');
                            let c = [
                                { sortable: true, width: columnWidth['Name'] || 0, ...(!columnWidth['Name'] ? { flex: 1 } : {}), type: 'string', disableColumnMenu: true, headerName: 'Name', field: 'name', renderCell: tableRenderers['name'] },
                                { sortable: true, width: columnWidth['Purpose'] || 0, ...(!columnWidth['Purpose'] ? { flex: 1 } : {}), type: 'string', disableColumnMenu: true, headerName: 'Purpose', field: 'purpose', renderCell: tableRenderers['purpose'] },
                                { sortable: true, width: columnWidth['Library'] || 0, ...(!columnWidth['Library'] ? { flex: 1 } : {}), type: 'string', disableColumnMenu: true, headerName: 'Library', field: 'folder', renderCell: tableRenderers['library'] },
                                { sortable: true, width: columnWidth['Author'] || 0, ...(!columnWidth['Author'] ? { flex: 0.5 } : {}), type: 'string', disableColumnMenu: true, headerName: 'Author', field: 'author', renderCell: tableRenderers['author'] },
                                { sortable: true, width: columnWidth['Modified'] || 0, ...(!columnWidth['Modified'] ? { flex: 1 } : {}), type: 'string', disableColumnMenu: true, headerName: 'Modified', field: 'time', renderCell: tableRenderers['modified'] },
                                { sortable: true, width: columnWidth['Version'] || 0, ...(!columnWidth['Version'] ? { flex: 0.5 } : {}), type: 'string', disableColumnMenu: true, headerName: 'Version', field: 'ver', renderCell: tableRenderers['version'] },
                                { sortable: true, width: columnWidth['Enabled'] || 0, ...(!columnWidth['Enabled'] ? { flex: 0.5 } : {}), type: 'string', disableColumnMenu: true, headerName: 'Enabled', field: 'enabled', renderCell: tableRenderers['enabled'] },
                            ];

                            if (p.columns && p.columns.length) {
                                c = p.columns.map(v => {
                                    for (let i = c.length; i--;) {
                                        if (v === c[i].headerName) {
                                            return c[i];
                                        }
                                    }
                                    return v;
                                });
                            }

                            return c;
                        })()}
                        disableMultipleColumnsFiltering
                        disableMultipleColumnsSorting
                        disableSelectionOnClick
                        disableColumnFilter
                        disableColumnMenu
                        sortModel={sort}
                        onSortModelChange={handleTableSort}
                        onColumnResize={handleColumnResize}
                        onColumnOrderChange={handleColumnReorder}
                    />
                </Box>
            </Box>
        </main>
    );
};

export default Zeek;
